import Icon from '../components/Icon.vue'

Icon.register({
  industry: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M475.1 163.8L336 252.3V184C336 165.1 315.1 153.6 299.1 163.8L160 252.3V56C160 42.7 149.3 32 136 32H24C10.7 32 0 42.7 0 56V456C0 469.3 10.7 480 24 480H488C501.3 480 512 469.3 512 456V184C512 165.1 491.1 153.6 475.1 163.8z'
      }
    ]
  }
})
